import React from 'react'
import axios from '@/utils/myaxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Button,
    Table,
    message,
    Input,
    Select,
    Tooltip,
    Tag,
    DatePicker,
    Switch,
    Dropdown,
    Menu,
    Icon,
    Form,
    Modal,
    InputNumber,
    Statistic
} from 'antd'
export default class ClubList extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            union_id: undefined,
            search_value: undefined,
            date: []
        },
        formData: {}, // 表单数据
        data: [], // 表格数据
        dataInfo: {}, // 数据信息
        unionClubList: [] // 联盟俱乐部列表
    };

    componentDidMount () {
        this.fetchData()
        this.fetchUnionClubList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/super_union_select_club', {
                params: {
                    ...this.state.queryParams,
                    search_type: this.state.queryParams.search_value
                        ? 'club_id'
                        : undefined,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf('day').valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf('day').valueOf() / 1000,
                    total: undefined,
                    date: undefined
                }
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                    dataInfo: res || {}
                })
            })
    };

    /**
     * 获取联盟俱乐部列表
     */
    fetchUnionClubList = () => {
        this.setState({ loading: true })
        axios.get('/v1/api/super_union_club_list').then((res) => {
            this.setState({
                unionClubList: res.data || []
            })
        })
    };

    /**
     * 设置是否能创建牌局
     */
    handleSetAllowCreate = (club_id, value) => {
        axios
            .patch('v1/api/super_union_club_allow_create', {
                id: club_id,
                allow: value
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"])
                    this.fetchData()
                }
            })
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.type === 'sendIntegral' ||
                    this.state.type === 'recycleIntegral'
                ) {
                    // 发放、回收积分
                    axios
                        .patch('/v1/api/trans_point', {
                            amount:
                                this.state.type === 'sendIntegral'
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            kind: 0,
                            level: 0,
                            cid: Number(this.state.formData.club_id),
                            club: Number(this.state.formData.club_id)
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"])
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                } else if (
                    this.state.type === 'sendDiamond' ||
                    this.state.type === 'recycleDiamond'
                ) {
                    // 发放、回收钻石
                    axios
                        .patch('/v1/api/diamond/super_union/club', {
                            amount:
                                this.state.type === 'sendDiamond'
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            id: Number(this.state.formData.club_id)
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"])
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                }
            }
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title
        switch (type) {
            case 'sendIntegral':
                title = this.props.language["sendIntergral"]
                break
            case 'recycleIntegral':
                title = this.props.language["recycleIntergral"]
                break
            case 'sendDiamond':
                title = this.props.language["sendDiamond"]
                break
            case 'recycleDiamond':
                title = this.props.language["recycleDiamond"]
                break
        }
        this.setState({
            show: true,
            type,
            title,
            formData: item
        })
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize
                }
            },
            () => this.fetchData()
        )
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value }
        })
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    union_id: undefined,
                    search_value: undefined,
                    date: []
                }
            },
            () => {
                this.fetchData()
            }
        )
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["clubIdPlaceholder"]}
                        value={this.state.queryParams.search_value}
                        onChange={(value) =>
                            this.handleSetQueryParamsData('search_value', value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["belongUnionPlaceholder"]}
                        value={this.state.queryParams.union_id}
                        onChange={(value) =>
                            this.handleSetQueryParamsData('union_id', value)
                        }
                    >
                        {this.state.unionClubList.map((item, index) => (
                            <Select.Option value={item.union_id} key={index}>
                                {item.union_name}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData('date', e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 概况 */}
                {/* <div className="common-main-card">
                    {this.props.language["counterPoint"]}
                    <div className="number-box-list">
                        <p>{this.props.language["counterPoint"]}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.point || 0)}
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                            </div>
                        </div>
                    </div>

                    {this.props.language["counterDiamond"]}
                    <div className="number-box-list">
                        <p>{this.props.language["counterDiamond"]}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.diamond || 0)}
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["clubId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/club_detail/${item.club_id}`}>{item.club_id || ''}</Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["clubName"]}
                            dataIndex="club_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["belongUnionId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/union_detail/${item.union_id}`}>
                                    {item.union_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["belongUnionName"]}
                            dataIndex="union_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["clubOwnerId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/player_detail/${item.user_id}/${item.club_id}`}>
                                    {item.user_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["clubOwnerName"]}
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinUnionTime"]}
                            dataIndex="created_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyAmount"]}
                            dataIndex=""
                            render={(item) => {
                                return (
                                    <div>
                                        <Tooltip title={this.props.language["superProxy"]}>
                                            <Tag color="purple">
                                                {item.club_member_cnt.super_agent_cnt}
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip title={this.props.language["oneProxy"]}>
                                            <Tag color="geekblue">
                                                {item.club_member_cnt.agent_cnt}
                                            </Tag>
                                        </Tooltip>
                                        <Tooltip title={this.props.language["twoProxy"]}>
                                            <Tag color="blue">{item.club_member_cnt.agent2_cnt}</Tag>
                                        </Tooltip>
                                        <Tooltip title={this.props.language["threeProxy"]}>
                                            <Tag color="cyan">{item.club_member_cnt.agent3_cnt}</Tag>
                                        </Tooltip>
                                        <Tooltip title={this.props.language["fourProxy"]}>
                                            <Tag color="green">{item.club_member_cnt.agent4_cnt}</Tag>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["palyerNumber"]}
                            dataIndex="club_member_cnt.user_cnt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterPoint"]}
                            dataIndex="point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterDiamond"]}
                            dataIndex="diamond"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_fee_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_ins_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_cowboy_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceDivide"]}
                            dataIndex=""
                            render={(item) => `${item.club_ins_mod === 1 ? this.props.language["risk"] : 'EV'}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyDivide"]}
                            dataIndex=""
                            render={(item) => `${item.club_cowboy_mod === 1 ? this.props.language["risk"] : 'EV'}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["allowCreateTable"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.allow_create === 1}
                                        onChange={(value) =>
                                            this.handleSetAllowCreate(item.club_id, value)
                                        }
                                    />
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => (
                                <>
                                    <Dropdown
                                        trigger={['click']}
                                        overlay={
                                            <Menu onClick={({ key }) => this.handleShow(key, item)}>
                                                <Menu.Item key="sendIntegral">
                                                    {this.props.language["sendIntergral"]}
                                                </Menu.Item>
                                                <Menu.Item key="recycleIntegral">
                                                    {this.props.language["recycleIntergral"]}
                                                </Menu.Item>
                                                <Menu.Item key="sendDiamond">
                                                    {this.props.language["sendDiamond"]}
                                                </Menu.Item>
                                                <Menu.Item key="recycleDiamond">
                                                    {this.props.language["recycleDiamond"]}
                                                </Menu.Item>
                                            </Menu>
                                        }
                                    >
                                        <Button type="primary" ghost>
                                            {this.props.language["operation"]}
                                            <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create()(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 发放回收积分/钻石 */}
                            {(this.props.type == 'sendIntegral' ||
                                this.props.type == 'recycleIntegral' ||
                                this.props.type == 'sendDiamond' ||
                                this.props.type == 'recycleDiamond') && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator('amount', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"]
                                                    }
                                                ]
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
